module.exports = __webpack_public_path__ + "assets/img/Back_logo.2edb3eed-ps.png";